
<script>import Loader from '/app/components/Loader.html'
import { tween } from 'svelte-extras'
import * as eases from 'eases-jsnext'
import { setFocus } from '/helpers/misc'
import { getElementOffset } from '/helpers/window'

export default {

	computed: {
		loaded(json) {
			return !!json
		},
		filteredPrograms: (loaded, json, programTypeFilter, collegeFilter) => {
			if (loaded && json.programs && json.programs.length) {
				let programs = json.programs.slice()
				if (programTypeFilter !== 'all') {
					programs = _.filter(programs, { programTypeFilter })
				}
				if (collegeFilter !== 'all') {
					programs = _.filter(programs, { collegeKey: collegeFilter })
				}
				return programs
			}
			return []
		},
		programGroups(filteredPrograms, json) {
			if (filteredPrograms && filteredPrograms.length) {
				let programs = _.groupBy(filteredPrograms, 'departmentKey')
				programs = _.map(programs, (list, key) => {
					const department = _.find(json.departments, { key })
					return {
						title: department.value,
						list,
					}
				})
				programs = _.orderBy(programs, 'title', 'asc')
				return programs
			}
			return []
		},
		alphabeticPrograms: filteredPrograms => _.orderBy(filteredPrograms, 'title', 'asc'),
		resultsCount: filteredPrograms => filteredPrograms.length,
		resultsClass: (groupsOffset, windowHeight, yPos) => groupsOffset >= windowHeight + yPos ? 'sticky' : '',
	},

	oncreate() {

		this.set({ yPos: window.pageYOffset })
		window.addEventListener('scroll', () => this.set({ yPos: window.pageYOffset }))

		// results button scroll handling
		this.observe('loaded', loaded => {
			if (loaded) {
				// we have to wait for the component to register in the DOM
				// because we use an `if` statement to render the DOM
				setTimeout(() => this.setSizedVars(), 0)
			}
		})

		// just some simple state management
		this.observe('programTypeFilter', programTypeFilter => this.checkState('programTypeFilter', programTypeFilter, 'all'))
		this.observe('collegeFilter', collegeFilter => this.checkState('collegeFilter', collegeFilter, 'all'))
		this.observe('sortFilter', sortFilter => this.checkState('sortFilter', sortFilter, 'department'))

		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => {
				this.set({ json })
			})
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))

		// I hate this indirection, but it works...
		this.observe('yPosMirror', yPos => {
			window.scrollTo(0, yPos)
		}, { init: false })
	},

	components: {
		Loader,
	},

	methods: {
		tween,
		setSizedVars() {
			this.set({ groupsOffset: getElementOffset(this.refs.groups) })
		},
		scrollToResults() {
			this.set({ yPosMirror: this.get('yPos') })
			this.tween('yPosMirror', getElementOffset(this.refs.groups), {
				duration: 1000,
				easing: eases.cubicOut,
			})
			// focus first item
			setFocus(this.refs.groups)
		},
		checkState(paramName, value, defaultValue) {
			const params = new URLSearchParams(window.location.search)
			const param = params.get(paramName)
			if (value) {
				params.set(paramName, value)
				history.replaceState(null, '', window.location.pathname + '?' + params.toString())
			} else {
				const setter = {}
				if (param) {
					setter[paramName] = param
					this.set(setter)
				} else {
					setter[paramName] = defaultValue
					this.set(setter)
					params.set(paramName, defaultValue)
					history.replaceState(null, '', window.location.pathname + '?' + params.toString())
				}
			}
		},
	},

}

</script><:Window bind:innerHeight="windowHeight" on:resize="setSizedVars()"/>{{#if loaded}}
<div class="controls grid-x grid-margin-x fullwidth">
  <div class="control small-12 medium-4">
    <fieldset>
      <legend class="h6">Show Me</legend>
      <div class="radio">
        <input id="program-type-0" type="radio" bind:group="programTypeFilter" value="all" name="program-types">
        <label for="program-type-0">All Program Types</label>
      </div>{{#each json.programTypeFilters as filter, index}}
      <div class="radio">
        <input type="radio" value="{{filter.key}}" bind:group="programTypeFilter" id="program-type-{{index + 1}}" name="program-types">
        <label for="program-type-{{index + 1}}">{{filter.value}}</label>
      </div>{{/each}}
    </fieldset>
  </div>
  <div class="control small-12 medium-4">
    <fieldset>
      <legend class="h6">From</legend>
      <div class="radio">
        <input id="college-0" type="radio" bind:group="collegeFilter" value="all" name="colleges">
        <label for="college-0">All Colleges</label>
      </div>{{#each json.colleges as college, index}}
      <div class="radio">
        <input type="radio" value="{{college.key}}" bind:group="collegeFilter" id="college-{{index + 1}}" name="colleges">
        <label for="college-{{index + 1}}">{{college.value}}</label>
      </div>{{/each}}
    </fieldset>
  </div>
  <div class="control small-12 medium-4">
    <fieldset>
      <legend class="h6">Sorted By</legend>
      <div class="radio">
        <input id="sort-0" type="radio" bind:group="sortFilter" value="department" name="sort">
        <label for="sort-0">Department</label>
      </div>
      <div class="radio">
        <input id="sort-1" type="radio" bind:group="sortFilter" value="alphabet" name="sort">
        <label for="sort-1">Alphabetical Order</label>
      </div>
    </fieldset>
  </div>
  <button class="results {{resultsClass}}" ref:results on:click="scrollToResults()"><span>{{resultsCount}} Results</span></button>
</div>{{#if sortFilter === 'department'}}
<div class="groups fullwidth" ref:groups>{{#each programGroups as programGroup, index}}
  <div class="group fullwidth">
    <h2 class="h4 title">{{programGroup.title}}</h2>
    <ul>{{#each programGroup.list as list}}
      <li><a href="{{list.url}}">{{list.title}}</a></li>{{/each}}
    </ul>
  </div>{{/each}}
</div>{{else}}
<div class="groups" ref:groups>
  <div class="group">
    <h2 class="h4 title">(Sorted by Alphabetical Order)</h2>
    <ul>{{#each alphabeticPrograms as program, index}}
      <li><a href="{{program.url}}">{{program.title}}</a></li>{{/each}}
    </ul>
  </div>
</div>{{/if}}{{else}}
<Loader></Loader>{{/if}}